import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { ViewStateTypes } from '@src/suite/common/enums/viewstate-types';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { NavigationApiActions } from '@src/suite/common/store/navigation/actions/navigation.actions';
import { selectCurrentViewState } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';

@Component({
    selector: 'st-discover-secondary-cta',
    imports: [MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './discover-secondary-cta.component.html',
    styleUrl: './discover-secondary-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-discover-secondary-cta',
    },
})
export class DiscoverSecondaryCtaComponent {
    store = inject(Store);
    nomWebServicesJson = inject(NomWebServicesJson);

    viewStateTypes = ViewStateTypes;

    languageSettings = this.store.selectSignal(selectI18N)();

    readonly viewState = computed(() => this.store.selectSignal(selectCurrentViewState)());

    readonly viewStateLoaded = computed(() => {
        return !!this.viewState();
    });

    readonly saveViewSettingsEnabled = computed(() => {
        if (this.viewState()?.Path?.isTeamView && !this.nomWebServicesJson?.HelloResults?.Supervisor) return false;
        return true;
    });

    public saveViewState() {
        this.store.dispatch(NavigationApiActions.saveCurrentNavigationItem());
    }
}
